import { TranslateModule } from '@ngx-translate/core';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddressValidatorComponent } from './address-validator.component';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { PopupModule } from '@progress/kendo-angular-popup';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { ButtonModule, ButtonsModule } from '@progress/kendo-angular-buttons';

@NgModule({
  declarations: [
    AddressValidatorComponent
  ],
  exports: [
    AddressValidatorComponent
  ],
  imports: [
    CommonModule,
    DialogsModule,
    PopupModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    InputsModule,
    ButtonModule,
    ButtonsModule,
  ]
})
export class AddressValidatorModule { }
